import { render, staticRenderFns } from "./JQuotaProgressTooltip.vue?vue&type=template&id=2c86b98c&scoped=true&"
import script from "./JQuotaProgressTooltip.vue?vue&type=script&lang=ts&"
export * from "./JQuotaProgressTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./JQuotaProgressTooltip.vue?vue&type=style&index=0&id=2c86b98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86b98c",
  null
  
)

export default component.exports